module.exports = __webpack_public_path__ + "static/media/ethereum.2a314aee.svg";